import script from "./BaseCheckboxGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseCheckboxGroup.vue?vue&type=script&setup=true&lang=ts"

import "./BaseCheckboxGroup.vue?vue&type=style&index=0&id=6add97a1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6add97a1"]])

export default __exports__